import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/checklists/")({
  head: () => buildRouteHead("/en/checklists", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/downloads/checklists", replace: true });
  },
});
